import React from 'react';
import style from './style.css';
import logo from './DoubleCheckLogoFooter.png';
import IESLogo from './IES-Institute_of_Education_Sciences.png';
import UVLogo from './UVLogo.png';
const { wpUrl } = window.cccisd.appDefs.app;

export default class Component extends React.Component {
    getYear = () => {
        const date = new Date().getFullYear();
        return date;
    };

    render() {
        const isQuest =
            window.location.pathname &&
            window.location.pathname.includes('/quest') &&
            window.location.pathname.includes('/design/flow');

        return (
            <div className={style.footer} id="layout_footer">
                <div>
                    <div className={isQuest ? style.none : style.logoBox}>
                        <img className={style.logo} alt="NOT FOUND" src={logo} width="200px" height="110px" />
                        <div className={style.textBox}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-around',
                                }}
                            >
                                <img
                                    alt="NOT FOUND"
                                    src={IESLogo}
                                    width="25%"
                                    style={{
                                        marginBottom: '20px',
                                        marginTop: '10px',
                                        maxWidth: '275px',
                                    }}
                                />
                                <img
                                    alt="NOT FOUND"
                                    src={UVLogo}
                                    width="25%"
                                    style={{
                                        marginBottom: '20px',
                                        marginTop: '10px',
                                        marginLeft: '2em',
                                        maxWidth: '275px',
                                    }}
                                />
                            </div>
                            <p style={{ maxWidth: '750px' }}>
                                Funded by the{' '}
                                <strong>U.S. Department of Education, Institute of Education Sciences,</strong>{' '}
                                R305A240235 awarded to Principal Investigator Dr. Catherine P. Bradshaw and R305C190014
                                awarded to Principal Investigator Dr. Wendy M. Reinke.
                            </p>
                        </div>
                        <div className={style.links}>
                            <a
                                style={{
                                    borderBottom: '1px solid grey',
                                    paddingRight: '3em',
                                    color: '#fff',
                                }}
                                href="https://www.doublecheckcoaching.org"
                            >
                                Home
                            </a>
                            <a style={{ color: '#fff' }} href={`${wpUrl}/contact/`}>
                                {' '}
                                Contact
                            </a>
                        </div>
                    </div>
                    <div className={style.wrapper}>
                        <div>
                            <span>
                                Website and software developed by <a href="https://www.3cisd.com/">3C Institute</a>.
                                <span className={style.spaceLeft}>© 2019-{this.getYear()} </span>
                                <a href="https://missouri.edu/">University of Missouri</a>.
                            </span>{' '}
                            <span className={style.spaceLeft}>All rights reserved. </span>
                            <span className={style.spaceLeft}>
                                <a href="https://www.3cisd.com/terms-of-use">Terms of Use</a> |{' '}
                                <a href="https://www.3cisd.com/privacy-policy">Privacy Policy</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
